import { MembershipsSpotifyIntegrationsApiClient } from '@fourthwall/services/dist/MembershipsSpotifyIntegrationsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDesyncPodcastMutation = createMutationHook(
  MembershipsSpotifyIntegrationsApiClient.desyncPodcast,
  {
    mutationKey: ['desyncPodcast'],
  },
)
